var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConVsNonConIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4 6.6C17.3578 5.20189 17.2017 4.36798 16.6239 3.79081C15.8323 3 14.5581 3 12.0097 3H8.40585C5.85751 3 4.58333 3 3.79167 3.79081C3 4.58162 3 5.85441 3 8.4V15.6C3 18.1456 3 19.4183 3.79167 20.2092C4.58333 21 5.85751 21 8.40585 21H12.0097C14.5581 21 15.8323 21 16.6239 20.2092C17.2017 19.632 17.3578 18.7981 17.4 17.4",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4 6.6C17.3578 5.20189 17.2017 4.36798 16.6239 3.79081C15.8323 3 14.5581 3 12.0097 3H8.40585C5.85751 3 4.58333 3 3.79167 3.79081C3 4.58162 3 5.85441 3 8.4V15.6C3 18.1456 3 19.4183 3.79167 20.2092C4.58333 21 5.85751 21 8.40585 21H12.0097C14.5581 21 15.8323 21 16.6239 20.2092C17.2017 19.632 17.3578 18.7981 17.4 17.4",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4177 11.7661L20.4771 10.7068C20.7205 10.4634 20.8421 10.3417 20.9072 10.2105C21.031 9.96069 21.031 9.66746 20.9072 9.41771C20.8421 9.28643 20.7205 9.16474 20.4771 8.92137C20.2337 8.678 20.112 8.55632 19.9808 8.49126C19.731 8.3675 19.4378 8.3675 19.1879 8.49126C19.0567 8.55632 18.935 8.678 18.6917 8.92137L17.6323 9.98073M19.4177 11.7661L14.6781 16.5057L12 17.3984L12.8927 14.7203L17.6323 9.98073M19.4177 11.7661L17.6323 9.98073",
    stroke: "#172B4D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7002 18.3008H6.6002L7.7252 16.0508L8.8502 18.3008H9.7502",
    stroke: "#6929E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6001 6.60156H13.8001",
    stroke: "#6929E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6001 10.1992H12.0001",
    stroke: "#6929E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConVsNonConIcon);
export default __webpack_public_path__ + "static/media/con_vs_non-con_icon.3a4cd6c77dab2b5b7ea9e1ba32816ec6.svg";
export { ForwardRef as ReactComponent };